/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import {
  Collapse,
  CircularProgress,
  Modal,
  Snackbar,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  ListItemSecondaryAction,
  Grid,
  Typography,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DropZone from '../../components/DropZone';
import { instanceAxios } from '../../InstanceAxios';

const useStyles = makeStyles((theme) => ({
  loading: {
    marginLeft: '50%',
  },
  modalAddTitle: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 2),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '40%',
    height: '40%',
    overflow: 'auto',
  },
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

function Documents({ idServico, addFile, setClose }) {
  const classes = useStyles();
  const url = 'http://vps19835.publiccloud.com.br/storage';
  const [documentos, setDocumentos] = useState([]);
  const [openModalAddFile, setOpenModalAddFile] = useState(false);
  const [ready, setReady] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [msgAlert, setMsgAlert] = useState('');
  const [typeAlert, setTypeAlert] = useState('');

  useEffect(() => {
    atualizarAnexos(idServico);
  }, [idServico]);

  const atualizarAnexos = async (id) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/anexoServico/${id}`)
      .then((res) => {
        setDocumentos(res.data);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setDocumentos([]);
        setReady(true);
      });
  };

  const saveFile = async (arrayFiles) => {
    setOpenModalAddFile(false);
    setReady(false);
    await arrayFiles.forEach(async (file, index) => {
      const data = new FormData();
      data.append('file', file);
      await instanceAxios(localStorage.getItem('toobiauth'))
        .post(`/uploadAnexoServico/servicoContratado/${idServico}`, data)
        .then((res) => {
          setMsgAlert('Upload realizado com sucesso!');
          setTypeAlert('success');
          setOpenAlert(true);
          setOpenModalAddFile(false);
          atualizarAnexos(idServico);
        })
        .catch((err) => {
          setMsgAlert('Erro ao fazer upload do arquivo');
          setTypeAlert('error');
          setOpenAlert(true);
          setOpenModalAddFile(false);
        });
    });
  };

  const clickAlert = () => {
    setOpenAlert(false);
    setMsgAlert('');
    setTypeAlert('');
  };

  return (
    <>
      <Collapse in={ready}>
        <Snackbar open={openAlert} autoHideDuration={6000} onClose={clickAlert}>
          <Alert variant="filled" severity={typeAlert} onClick={clickAlert}>
            {msgAlert}
          </Alert>
        </Snackbar>
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h4" gutterBottom>
            Enviar arquivos
          </Typography>
          <Button
            size="medium"
            variant="contained"
            color="primary"
            onClick={() => setOpenModalAddFile(true)}
            startIcon={<CloudUploadIcon />}
            style={{ marginTop: '15%' }}
          >
            Upload
          </Button>
        </Grid>
      </Collapse>
      <Collapse in={!ready}>
        <CircularProgress className={classes.loading} />
      </Collapse>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={openModalAddFile}
        onClose={() => setOpenModalAddFile(false)}
      >
        <div className={classes.modalAddTitle}>
          <DropZone handleButtonClick={saveFile} />
        </div>
      </Modal>
    </>
  );
}

export default Documents;
